const blank = (overrides = {}) => ({
  financial_year: [],
  location_id: [],
  sublocation_id: [],
  category: [],
  sub_category: [],
  kpi: [],
  displayPeriods: [],
  ...overrides,
});

// ───────────────── SUMMARY CONFIGS ─────────────────

const summaryConfigs = {
  Diversity: {
    module: "Diversity",
    cards: [

      {
        id: "total_employees",
        title: "Total Employees",
        description: "",
        representationType: "Summary",
        dataSourceType: "REPORTING",
        trendDirection: "up",
        comparison: { type: "previous_period", field: "financialYear" },
        group_by: ["metric_name"],
        flatten_from: ["FR1"],
        formulas: [
          {
            metric_name: "Total Employees",
            formula: "{{DC1}}",
            apply_formula_group_by: ["location_id"],
            group_by: ["metric_name"],
            aggregate: { sum: "value" }
          }
        ],
        dataConfigs: [
          {
            widgetConfig: {
              module: ["Employment"],
              latest: true,
              filters: blank({
                category: ["Employment"],
                sub_category: ["Full-time Employee (in Number)"],
                kpi: ["Full-time Employees"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          }
        ]
      },
      {
        id: "gender_diversity_female",
        title: "Female Employees in percentage",
        description: "",
        representationType: "Summary",
        dataSourceType: "REPORTING",
        skipComparisonView: true,
        trendDirection: "up",
        comparison: { 
          type: "dimension", 
          field: "metric_name",
          values: ["Female", "Male"],
          comparisonType: "percentage_share"
        },
        group_by: ["metric_name"],
        flatten_from: ["FR1", "FR2"],
        formulas: [
          {
            metric_name: "Female",
            formula: "{{DC2}}*{{DC1}}/100",
            apply_formula_group_by: ["location_id"],
            group_by: ["metric_name"],
            aggregate: { sum: "value" }
          },
          {
            metric_name: "Male",
            formula: "(100-{{DC2}})*{{DC1}}/100",
            apply_formula_group_by: ["location_id"],
            group_by: ["metric_name"],
            aggregate: { sum: "value" }
          },
        ],
        dataConfigs: [
          {
            widgetConfig: {
              module: ["Employment"],
              latest: true,
              filters: blank({ category: ["Employment"], sub_category: ["Full-time Employee (in Number)"], kpi: ["Full-time Employees"] }),
              group_by: ["kpi", "location_id", "displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true,
            },
          },
          {
            widgetConfig: {
              module: ["Diversity"],
              latest: true,
              filters: blank({ category: ["Employee Diversity"], sub_category: ["Current employees (in %)"], kpi: ["Female"] }),
              group_by: ["kpi", "location_id", "displayPeriods"],
              aggregate: { avg: "value" },
              aggregateSubLocations: true,
            },
          }
        ],
      },
      {
        id: "female_employees",
        title: "Female Employees",
        description: "",
        representationType: "Summary",
        dataSourceType: "REPORTING",
        trendDirection: "up",
        comparison: { type: "previous_period", field: "financialYear" },
        group_by: ["metric_name"],
        flatten_from: ["FR1"],
        formulas: [
          {
            metric_name: "Female Employees",
            formula: "{{DC1}}*{{DC2}}/100",
            apply_formula_group_by: ["location_id"],
            group_by: ["metric_name"],
            aggregate: { sum: "value" }
          }
        ],
        dataConfigs: [
          {
            widgetConfig: {
              module: ["Employment"],
              latest: true,
              filters: blank({
                category: ["Employment"],
                sub_category: ["Full-time Employee (in Number)"],
                kpi: ["Full-time Employees"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          },
          {
            widgetConfig: {
              module: ["Diversity"],
              latest: true,
              filters: blank({
                category: ["Employee Diversity"],
                sub_category: ["Current employees (in %)"],
                kpi: ["Female"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { avg: "value" },
              aggregateSubLocations: true
            }
          }
        ]
      },

      {
        id: "male_employees",
        title: "Male Employees",
        description: "",
        representationType: "Summary",
        dataSourceType: "REPORTING",
        trendDirection: "up",
        comparison: { type: "previous_period", field: "financialYear" },
        group_by: ["metric_name"],
        flatten_from: ["FR1"],
        formulas: [
          {
            metric_name: "Male Employees",
            formula: "{{DC1}}*{{DC2}}/100",
            apply_formula_group_by: ["location_id"],
            group_by: ["metric_name"],
            aggregate: { sum: "value" }
          }
        ],
        dataConfigs: [
          {
            widgetConfig: {
              module: ["Employment"],
              latest: true,
              filters: blank({
                category: ["Employment"],
                sub_category: ["Full-time Employee (in Number)"],
                kpi: ["Full-time Employees"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          },
          {
            widgetConfig: {
              module: ["Diversity"],
              latest: true,
              filters: blank({
                category: ["Employee Diversity"],
                sub_category: ["Current employees (in %)"],
                kpi: ["Male"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          }
        ]
      },

      {
        id: "employees_below_30_years",
        title: "Employees Below 30 Years",
        description: "",
        representationType: "Summary",
        dataSourceType: "REPORTING",
        trendDirection: "up",
        comparison: { type: "previous_period", field: "financialYear" },
        group_by: ["metric_name"],
        flatten_from: ["FR1"],
        formulas: [
          {
            metric_name: "Employees Below 30 Years",
            formula: "{{DC1}}*{{DC2}}/100",
            apply_formula_group_by: ["location_id"],
            group_by: ["metric_name"],
            aggregate: { sum: "value" }
          }
        ],
        dataConfigs: [
          {
            widgetConfig: {
              module: ["Employment"],
              latest: true,
              filters: blank({
                category: ["Employment"],
                sub_category: ["Full-time Employee (in Number)"],
                kpi: ["Full-time Employees"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          },
          {
            widgetConfig: {
              module: ["Diversity"],
              latest: true,
              filters: blank({
                category: ["Employee Diversity"],
                sub_category: ["Current employees (in %)"],
                kpi: ["< 30 yrs"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          }
        ]
      },
      {
        id: "employees_beteween_30_to_50_years",
        title: "Employees Between 30-50 Years",
        description: "",
        representationType: "Summary",
        dataSourceType: "REPORTING",
        trendDirection: "up",
        comparison: { type: "previous_period", field: "financialYear" },
        group_by: ["metric_name"],
        flatten_from: ["FR1"],
        formulas: [
          {
            metric_name: "Employees Between 30-50 Years",
            formula: "{{DC1}}*{{DC2}}/100",
            apply_formula_group_by: ["location_id"],
            group_by: ["metric_name"],
            aggregate: { sum: "value" }
          }
        ],
        dataConfigs: [
          {
            widgetConfig: {
              module: ["Employment"],
              latest: true,
              filters: blank({
                category: ["Employment"],
                sub_category: ["Full-time Employee (in Number)"],
                kpi: ["Full-time Employees"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          },
          {
            widgetConfig: {
              module: ["Diversity"],
              latest: true,
              filters: blank({
                category: ["Employee Diversity"],
                sub_category: ["Current employees (in %)"],
                kpi: ["30–50 yrs"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          }
        ]
      },
      {
        id: "employees_above_50_years",
        title: "Employees Above 50 Years",
        description: "",
        representationType: "Summary",
        dataSourceType: "REPORTING",
        trendDirection: "up",
        comparison: { type: "previous_period", field: "financialYear" },
        group_by: ["metric_name"],
        flatten_from: ["FR1"],
        formulas: [
          {
            metric_name: "Employees Above 50 Years",
            formula: "{{DC1}}*{{DC2}}/100",
            apply_formula_group_by: ["location_id"],
            group_by: ["metric_name"],
            aggregate: { sum: "value" }
          }
        ],
        dataConfigs: [
          {
            widgetConfig: {
              module: ["Employment"],
              latest: true,
              filters: blank({
                category: ["Employment"],
                sub_category: ["Full-time Employee (in Number)"],
                kpi: ["Full-time Employees"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          },
          {
            widgetConfig: {
              module: ["Diversity"],
              latest: true,
              filters: blank({
                category: ["Employee Diversity"],
                sub_category: ["Current employees (in %)"],
                kpi: ["> 50 yrs"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          }
        ]
      },
    ]
  }
};

// ───────────────── GRAPH CONFIGS ─────────────────

const graphConfigs = {

  "Gender Diversity": {
    title: "Gender Diversity",
    description: "Workforce gender composition",
    chartType: "donut",
    representationType: "Graph",
    dataSourceType: "REPORTING",
    group_by: ["metric_name"],
    flatten_from: ["FR2","FR3"],
    formulas: [
      {
        metric_name: "Total Employees",
        formula: "{{DC1}}",
        apply_formula_group_by: ["location_id"],
        group_by: ["metric_name"],
        aggregate: { sum: "value" }
      },
      {
        metric_name: "Female Employees",
        formula: "{{DC1}}*{{DC2}}/100",
        apply_formula_group_by: ["location_id"],
        group_by: ["metric_name"],
        aggregate: { sum: "value" }
      },
      {
        metric_name: "Male Employees",
        formula: "{{FR1}} - {{FR2}}",
        apply_formula_group_by: ["metric_name"],
        group_by: ["metric_name"],
        aggregate: { sum: "value" }
      }
    ],
    dataConfigs: [
      {
        widgetConfig: {
          module: ["Employment"],
          latest: true,
          filters: blank({
            category: ["Employment"],
            sub_category: ["Full-time Employee (in Number)"],
            kpi: ["Full-time Employees"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { sum: "value" },
          aggregateSubLocations: true
        }
      },
      {
        widgetConfig: {
          module: ["Diversity"],
          latest: true,
          filters: blank({
            category: ["Employee Diversity"],
            sub_category: ["Current employees (in %)"],
            kpi: ["Female"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { avg: "value" },
          aggregateSubLocations: true
        }
      }
    ]
  },

  "Gender Diversity Trend": {
    title: "Gender Diversity Trend",
    description: "Trend of female workforce percentage",
    chartType: "line",
    representationType: "Graph",
    dataSourceType: "REPORTING",
    group_by: ["displayPeriods", "metric_name"],
    flatten_from: ["FR2","FR3", "FR1"],
    formulas: [
      {
        metric_name: "Total Employees",
        formula: "{{DC1}}",
        apply_formula_group_by: ["location_id", "displayPeriods"],
        group_by: ["metric_name", "displayPeriods"],
        aggregate: { sum: "value" }
      },
      {
        metric_name: "Female Employees",
        formula: "{{DC1}}*{{DC2}}/100",
        apply_formula_group_by: ["location_id", "displayPeriods"],
        group_by: ["metric_name", "displayPeriods"],
        aggregate: { sum: "value" }
      },
      {
        metric_name: "Male Employees",
        formula: "{{FR1}} - {{FR2}}",
        apply_formula_group_by: ["metric_name", "displayPeriods"],
        group_by: ["metric_name", "displayPeriods"],
        aggregate: { sum: "value" }
      }
    ],
    dataConfigs: [
      {
        widgetConfig: {
          module: ["Employment"],
          filters: blank({
            category: ["Employment"],
            sub_category: ["Full-time Employee (in Number)"],
            kpi: ["Full-time Employees"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { sum: "value" },
          aggregateSubLocations: true
        }
      },
      {
        widgetConfig: {
          module: ["Diversity"],
          filters: blank({
            category: ["Employee Diversity"],
            sub_category: ["Current employees (in %)"],
            kpi: ["Female"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { avg: "value" },
          aggregateSubLocations: true
        }
      }
    ]
  },

  "Age Diversity": {
    title: "Age Diversity",
    description: "Workforce age composition",
    chartType: "donut",
    representationType: "Graph",
    dataSourceType: "REPORTING",
    group_by: ["metric_name"],
    flatten_from: ["FR1","FR2","FR3"],
    formulas: [
      {
        metric_name: "Employees Below 30 Years",
        formula: "{{DC1}}*{{DC2}}/100",
        apply_formula_group_by: ["location_id"],
        group_by: ["metric_name"],
        aggregate: { sum: "value" }
      },
      {
        metric_name: "Employees Between 30-50 Years",
        formula: "{{DC1}}*{{DC3}}/100",
        apply_formula_group_by: ["location_id"],
        group_by: ["metric_name"],
        aggregate: { sum: "value" }
      },
      {
        metric_name: "Employees Above 50 Years",
        formula: "{{DC1}}*{{DC4}}/100",
        apply_formula_group_by: ["location_id"],
        group_by: ["metric_name"],
        aggregate: { sum: "value" }
      }
    ],
    dataConfigs: [
      {
        widgetConfig: {
          module: ["Employment"],
          latest: true,
          filters: blank({
            category: ["Employment"],
            sub_category: ["Full-time Employee (in Number)"],
            kpi: ["Full-time Employees"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { sum: "value" },
          aggregateSubLocations: true
        }
      },
      {
        widgetConfig: {
          module: ["Diversity"],
          latest: true,
          filters: blank({
            category: ["Employee Diversity"],
            sub_category: ["Current employees (in %)"],
            kpi: ["< 30 yrs"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { avg: "value" },
          aggregateSubLocations: true
        }
      },
      {
        widgetConfig: {
          module: ["Diversity"],
          latest: true,
          filters: blank({
            category: ["Employee Diversity"],
            sub_category: ["Current employees (in %)"],
            kpi: ["30–50 yrs"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { avg: "value" },
          aggregateSubLocations: true
        }
      },
      {
        widgetConfig: {
          module: ["Diversity"],
          latest: true,
          filters: blank({
            category: ["Employee Diversity"],
            sub_category: ["Current employees (in %)"],
            kpi: ["> 50 yrs"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { avg: "value" },
          aggregateSubLocations: true
        }
      }
    ]
  },

  "Age Diversity Trend": {
    title: "Age Diversity Trend",
    description: "Trend of workforce age distribution",
    chartType: "line",
    representationType: "Graph",
    dataSourceType: "REPORTING",
    group_by: ["displayPeriods","metric_name"],
    flatten_from: ["FR1", "FR2","FR3","FR4"],
    formulas: [
      {
        metric_name: "Total Employees",
        formula: "{{DC1}}",
        apply_formula_group_by: ["location_id", "displayPeriods"],
        group_by: ["metric_name", "displayPeriods"],
        aggregate: { sum: "value" }
      },
      {
        metric_name: "Employees Below 30 Years",
        formula: "{{DC1}}*{{DC2}}/100",
        apply_formula_group_by: ["location_id","displayPeriods"],
        group_by: ["metric_name","displayPeriods"],
        aggregate: { sum: "value" }
      },
      {
        metric_name: "Employees Between 30-50 Years",
        formula: "{{DC1}}*{{DC3}}/100",
        apply_formula_group_by: ["location_id","displayPeriods"],
        group_by: ["metric_name","displayPeriods"],
        aggregate: { sum: "value" }
      },
      {
        metric_name: "Employees Above 50 Years",
        formula: "{{DC1}}*{{DC4}}/100",
        apply_formula_group_by: ["location_id","displayPeriods"],
        group_by: ["metric_name","displayPeriods"],
        aggregate: { sum: "value" }
      }
    ],
    dataConfigs: [
      {
        widgetConfig: {
          module: ["Employment"],
          filters: blank({
            category: ["Employment"],
            sub_category: ["Full-time Employee (in Number)"],
            kpi: ["Full-time Employees"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { sum: "value" },
          aggregateSubLocations: true
        }
      },
      {
        widgetConfig: {
          module: ["Diversity"],
          filters: blank({
            category: ["Employee Diversity"],
            sub_category: ["Current employees (in %)"],
            kpi: ["< 30 yrs"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { avg: "value" },
          aggregateSubLocations: true
        }
      },
      {
        widgetConfig: {
          module: ["Diversity"],
          filters: blank({
            category: ["Employee Diversity"],
            sub_category: ["Current employees (in %)"],
            kpi: ["30–50 yrs"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { avg: "value" },
          aggregateSubLocations: true
        }
      },
      {
        widgetConfig: {
          module: ["Diversity"],
          filters: blank({
            category: ["Employee Diversity"],
            sub_category: ["Current employees (in %)"],
            kpi: ["> 50 yrs"]
          }),
          group_by: ["kpi","location_id","displayPeriods"],
          aggregate: { avg: "value" },
          aggregateSubLocations: true
        }
      }
    ]
  },

};

// ───────────────── FINAL CONFIG ─────────────────

const hrsrDiversityConfig = {
  label: "HRSR-Diversity",
  description: "Workforce Diversity & Inclusion Metrics",
  apiKeys: ["diversity","hrsr diversity","gender diversity"],
  modules: ["Diversity","Employment"],
  summaryConfigs,
  graphConfigs
};

export default hrsrDiversityConfig;